import CommentForm from '../../features/commentForm/CommentForm';
import Comment from '../comment/Comment';
import './CommentList.css';

export default function CommentList({comments}) {
    return (
        <div className="comments">
            <h4>Comments:</h4>
            <CommentForm />
            {comments.length < 1 ? <p>No comments</p>: comments.map(comment => <Comment comment={comment}/>)}
        </div>
    )
}